export default __webpack_public_path__ + "static/media/vova_facebook.cef25e60.jpg";